<template>
	<v-dialog
		:value="dialog"
		:persistent="persistent"
		max-width="950%"
		@input="$emit('close-modal', $event)"
	>	
		<div>
			<v-card class="new-survey open-modal"
				:style="`height: ${height}%;`">
				<div class="design-scale-chart-close" v-if="closeModel">
					<close-icon class="cursor-pointer" @click="$emit('close', $event)"></close-icon>
				</div>
				<slot></slot>
			</v-card>
			<div class="background-footer-modal" v-if="footer">
				<v-layout wrap justify-center>
					<v-flex xs2 mx-1>
						<v-btn
							:color="color"
							type="button"
							class="btn btn-action btn-disabled-background"
							:disabled="create"
							@click="$emit('create-employee')"
						>
							{{ title }}
						</v-btn>
					</v-flex>
				</v-layout>
			</div>
		</div>
	</v-dialog>
</template>

<script>
import CloseIcon from '@/modules/shared/components/icons/close-icon';

export default {
	name: 'open-modal',
	components: {
		CloseIcon,
	},
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		create: {
			type: Boolean,
			default: true,
		},
		footer: {
			default: true,
			type: Boolean,
		},
		title: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: 'primary',
		},
		smallModel: {
			type: Boolean,
			default: false,
		},
		height: {
			default: 80,
		},
		closeModel: {
			type: Boolean,
			default: false,
		},
		persistent: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.open-modal{
	background-color: map-get($colors, gray-light);
	box-shadow: 0 2px 21px 0 rgba(68, 68, 68, 0.5);
	position: relative;
	width: 100%;
	// height: 80%;
	@media (max-width: 768px){
		width: 100%;
		// height: 41%;
		zoom:100%;
	}
}
.background-footer-modal {
	background-color: map-get($colors, white);
	bottom: 0;
	left: 0;
	padding: 1px;
	position: absolute;
	width: 100%;
}

.v-dialog {
	margin: 0 !important;
}
.design-scale-chart-close {
	position: absolute;
	right: 20px;
	top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/open-modal.vue